import { render, staticRenderFns } from "./head.vue?vue&type=template&id=8dc1336a&scoped=true&"
import script from "./head.vue?vue&type=script&lang=js&"
export * from "./head.vue?vue&type=script&lang=js&"
import style0 from "./head.vue?vue&type=style&index=0&id=8dc1336a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc1336a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8dc1336a')) {
      api.createRecord('8dc1336a', component.options)
    } else {
      api.reload('8dc1336a', component.options)
    }
    module.hot.accept("./head.vue?vue&type=template&id=8dc1336a&scoped=true&", function () {
      api.rerender('8dc1336a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/assets/head.vue"
export default component.exports